import React from 'react'

const Coloredcardholder = () => {
    return (
        <>
            <section id='colored-card' >

                <div className="">
                    <div class="text-center p-2 mt-5 ">
                        <h2 className='mt-2' style={{
                            color:
                                'rgba(37, 70, 74, 1)'
                        }}>Running successfully with 50+ Indian Companies
                        </h2>


                    </div>
                    <div className=" d-flex text-center flex-row justify-content-around mb-5">
                        <img className='imgage-fluid auto-icon-width' src="./images/iconholder/walmart.svg" alt="" />
                        <img className='image-fluid auto-icon-width' src="./images/iconholder/google.svg" alt="" />
                        <img className='image-fluid auto-icon-width' src="./images/iconholder/chase.svg" alt="" />
                        <img className='image-fluid auto-icon-width' src="./images/iconholder/hexawire.svg" alt="" />
                        <img className='image-fluid auto-icon-width' src="./images/iconholder/lafrage.svg" alt="" />

                    </div>
                </div>
                <div className="container mt-5 d-flex justify-content-center" >
                    <div class="grid-container">
                        <div class="item1 ">
                            <div className="colored-card shadow " style={{background:"url('./images/blend/1.svg') center/100% no-repeat"}}>



                                <div className="colored-card-overlay " style={{ background: " rgba(15, 70, 153, 0.58)" }}>
                                </div>

                                <div style={{ position: "absolute" }} className=' '>
                                    <div className='colored-box-text-wrapper'>
                                        <div className=''>
                                            <div className='encourage-text' ><h2>Encourage</h2></div>
                                            <div className='encourage-text'> <h2>Engagement</h2></div>

                                        </div>

                                        <div className='d-flex '>
                                            <div> <img src="./images/blend/up arrow.png" alt="" className='up-arrow ' /></div>
                                            <div className='encourage-text percentage'><h2>15%</h2></div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div class="item2">
                            <div className="colored-card shadow " style={{background:"url('./images/blend/2.svg') center/100% no-repeat"}}>



                                <div className="colored-card-overlay " style={{ background: "rgba(128, 0, 128, 0.45) " }}>
                                </div>

                                <div style={{ position: "absolute" }} className=' '>
                                    <div className='colored-box-text-wrapper'>
                                        <div className=''>
                                            <div className='  encourage-text' > <h2>Create a culture</h2></div>
                                            <div className='encourage-text' ><h2>of appreciation</h2></div>

                                        </div>

                                        <div className='d-flex '>
                                            <img src="./images/blend/up arrow.png" alt="" className='up-arrow ' />
                                            <div className='encourage-text percentage'><h2>15%</h2></div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div class="item3">
                            <div >
                                <div className="colored-card shadow "  style={{background:"url('./images/blend/3.svg') center/100% no-repeat"}}>



                                    <div className="colored-card-overlay " style={{ background: "rgba(0, 128, 128, 0.78)" }}>
                                    </div>

                                    <div style={{ position: "absolute" }} className='  '>
                                        <div className='colored-box-text-wrapper'>
                                            <div className=''>
                                                <div className=' encourage-text' > <h2>Be a workplace</h2></div>
                                                <div className=' encourage-text' ><h2>people love to work</h2> </div>

                                            </div>

                                            <div className='d-flex '>
                                                <img src="./images/blend/up arrow.png" alt="" className='up-arrow ' />
                                                <div className='encourage-text percentage'><h2>15%</h2></div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="item1">
                            <div className="colored-card shadow "  style={{background:"url('./images/blend/4.svg') center/100% no-repeat"}}>



                                <div className="colored-card-overlay " style={{ background: "rgba(128, 0, 128, 0.54)" }}>
                                </div>

                                <div style={{ position: "absolute" }} className=' encourage-text '>
                                    <div className='colored-box-text-wrapper'>
                                        <div className=''>
                                            <div className=' encourage-text' ><h2>Enhance</h2> </div>
                                            <div className=' encourage-text' ><h2>efficiency</h2>  </div>

                                        </div>

                                        <div className='d-flex  '>
                                            <img src="./images/blend/up arrow.png" alt="" className='up-arrow ' />
                                            <div className=' encourage-text percentage'><h2>15%</h2></div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div class="item2">
                            <div className="colored-card shadow "  style={{background:"url('./images/blend/5.svg') center/100% no-repeat"}}>



                                <div className="colored-card-overlay " style={{ background: "rgba(178, 24, 14, 0.69)" }}  >
                                </div>

                                <div style={{ position: "absolute" }} className=' encourage-text '>
                                    <div className='colored-box-text-wrapper'>

                                        <div className=' encourage-text' ><h2>Best ROI on an</h2></div>
                                        <div className=' encourage-text'> <h2>incentive programmes </h2></div>



                                        <div className='d-flex  '>
                                            <img src="./images/blend/up arrow.png" alt="" className='up-arrow ' />
                                            <div className='encourage-text percentage'><h2>100%</h2></div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div class="item3">
                            <div className="colored-card shadow " style={{background:"url('./images/blend/6.svg') center/100% no-repeat"}} >



                                <div className="colored-card-overlay " style={{ background: "rgba(15, 70, 153, 0.45)" }}  >
                                </div>

                                <div style={{ position: "absolute" }} className=' '>
                                    <div className='colored-box-text-wrapper' >
                                        <div className=''>
                                            <div className='encourage-text'><h2>Nurture</h2></div>
                                            <div className='encourage-text'><h2>innovation</h2></div>

                                        </div>

                                        <div className='d-flex  '>
                                            <img src="./images/blend/up arrow.png" alt="" className='up-arrow ' />
                                            <div className='encourage-text percentage'><h2>15%</h2></div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>


                    </div>
                </div>

            </section>
        </>
    )
}

export default Coloredcardholder